"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendServiceRequest = exports.getFullUrl = void 0;
const Routing_1 = require("../../common/Routing");
const getFullUrl = (protocol, domain, basePath = "", path = "", port) => {
    const portString = !!port ? `:${port}` : "";
    const fullPath = (0, Routing_1.mergeStringPaths)(basePath, path);
    return `${protocol}://${domain}${portString}${fullPath}`;
};
exports.getFullUrl = getFullUrl;
const sendServiceRequest = (config, path = "", args = []) => __awaiter(void 0, void 0, void 0, function* () {
    const { protocol, domain, port, basePath = "", authorization = "" } = config;
    const fullUrl = (0, exports.getFullUrl)(protocol, domain, basePath, path, port);
    const requestHeaders = !!authorization
        ? {
            Authorization: `Bearer ${authorization}`,
        }
        : undefined;
    const response = yield fetch(fullUrl, {
        headers: requestHeaders,
        credentials: "same-origin",
        method: "POST",
        body: JSON.stringify(args),
    });
    const { ok: responseIsOk } = response;
    const data = yield response.json();
    if (responseIsOk) {
        return data;
    }
    else {
        throw data;
    }
});
exports.sendServiceRequest = sendServiceRequest;
